import { Grid, useMediaQuery } from '@mui/material';
import React from 'react';
import { SmartMultiHero } from '../components/PostQuiz/SmartMultiHero';
import { NutrientsSection } from '../components/PostQuiz/NutrientsSection';
import { PersonalizationStepper } from '../components/PostQuiz/PersonalizationStepper';
import { CarouselUpsellSection } from '../components/PostQuiz/CarouselUpsellSection';
import { colors, theme } from '../utils/theme';
import { ProductComparisonSection } from '../components/PostQuiz/ProductComparisonSection';
import { UserReviewsSection } from '../components/PostQuiz/UserReviewsSection';
import { StressUpsellSection } from '../components/PostQuiz/StressUpsellSection';
import { DirectToDashboardSection } from '../components/PostQuiz/DirectToDashboardSection';

export const PostQuizPage = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid
      container
      flexDirection="column"
      alignItems={isMobile ? 'flex-start' : 'center'}
      justifyContent="center"
      sx={{
        background: colors.greys.BG_WHITE,
      }}
    >
      <SmartMultiHero />

      <NutrientsSection />
      <PersonalizationStepper />
      <CarouselUpsellSection />
      <ProductComparisonSection />
      <UserReviewsSection />
      <StressUpsellSection />
      <DirectToDashboardSection />
    </Grid>
  );
};
